import styled from 'styled-components'

export const FeedbackWrapper = styled.div`
  ${({ isALRedesign }) => isALRedesign && `
    background : #121212 !important;
  `}
`
